import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import { QuestionnaireEditorPage } from './questionnaire-editor/QuestionnaireEditorPage';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/questionnaire/add')({
    staticData: {
        presentation: 'fullPage',
        metadata: {
            title: 'New questionnaire',
        },
        breadcrumb: {
            title: 'New questionnaire',
        },
        ui: {
            icon: ClipboardList,
            title: 'New questionnaire',
            subtitle: 'Build a claim lodgement questionnaire',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
    },
    component: AddQuestionnaireRoute,
});

function AddQuestionnaireRoute() {
    return (
        <PageController route={Route}>
            <QuestionnaireEditorPage mode={['add']} />
        </PageController>
    );
}
